import React, { useState, useRef, useEffect } from "react";
import style from "./newRequest.module.scss"
import Modal from "../../Modal/Modal"
import check from "../../../assets/testIcon/checked.svg"
import DropDown from "../../Dropdown/SimpleDropDown/DropDown"
import Button from "../../Button/button";

const NewRequest = (props) => {

    const [requestData, setRequestData] = useState({
        category: null,
        content: '',
    })

    const [requestState, setRequestState] = useState({ state: 'empty' })

    const handleRequestProperty = (tag, e) => {
        let tmp = requestData
        if (tag == 'content') {
            tmp[tag] = e.target.value
        } else {
            tmp[tag] = e.name
        }
        setRequestData({ ...requestData })
    }

    const sendDataToParent = async () => {
        setRequestState({ ...requestState, state: 'loading' })
        let res = await props.sendRequest(requestData)
        if (res) {
            setRequestState({ ...requestState, state: 'success' })
            let tmp = requestData
            tmp.category = ''
            tmp.content = ''
            setRequestData({ ...tmp })
        }
    }

    const closeModal = () => {
        setRequestState({ ...requestState, state: 'empty' })
        let tmp = requestData
        tmp.category = ''
        tmp.content = ''
        setRequestData({ ...tmp })
        props.parentClose()
    }

    return (
        <Modal
            tag='newRequest'
            value={props.value}
            title='درخواست جدید'
            parentClose={closeModal}
        >
            <div className={style.wrapper}>
                {requestState.state == 'success' ? <div className={style.successWrapper}>
                    <img alt="success" src={check} className={style.check}></img>
                    <p>درخواست شما با موفقیت ارسال شد</p>
                </div>
                    :
                    <>
                        <div className={style.category}>
                            <DropDown
                                tag={'category'}
                                label='دسته‌بندی درخواست'
                                placeHolder={'انتخاب دسته‌بندی'}
                                value={requestData.category}
                                dropdownList={[{ _id: 0, name: 'ویژگی جدید' }, { _id: 1, name: 'بهبود ویژگی' }, { _id: 2, name: 'مشکل در سایت' }]}
                                handleSelect={handleRequestProperty}
                                deleteAll={() => setRequestData({ ...requestData, category: '' })}
                            />
                        </div>

                        <div className={style.textAreaWrapper}>
                            <p className={style.textAreaLabel}>متن درخواست</p>
                            <textarea value={requestData.content} onChange={(e) => handleRequestProperty('content', e)}></textarea>
                        </div>
                        <div className={style.buttonWrapper}>
                            <div className={style.postBtn}>
                                <Button
                                    tag="postButton"
                                    loading={requestState.state == 'loading' ? true : false}
                                    type="solid"
                                    label='ایجاد درخواست'
                                    disabled={(requestData.content != '' && requestData.category != '') ? false : true}
                                    onclick={sendDataToParent}
                                />
                            </div>
                            <div className={style.cancelBtn}>
                                <Button
                                    tag="cancelButton"
                                    type="outline"
                                    label="انصراف"
                                    onclick={closeModal}
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
        </Modal>
    );
}

export default NewRequest;
